module.exports = __webpack_public_path__ + "static/img/lianxiwe_banner.f0ab567.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lianxiwe_banner.png
// module id = i1Jz
// module chunks = 0